const controller = function(
	$scope,
	$filter,
	Session,
	User,
	$ionicLoading,
	$interval,
) {
	"ngInject"

	var vm = this;
	var interval;

	vm.scopes = [
		{ value: 'day', display: $filter('ucfirst')($filter('translate')('today')) },
		{ value: 'yesterday', display: $filter('ucfirst')($filter('translate')('yesterday')) },
		{ value: 'week', display: $filter('ucfirst')($filter('translate')('thisweek')) },
		{ value: 'month', display: $filter('ucfirst')($filter('translate')('thismonth')) },
	];

	if (Session.get('statisticsScope')) {
		vm.scope = Session.get('statisticsScope');
	} else {
		vm.scope = vm.scopes[0].value;
	}

	function initialize() {
		User.get({
			time: vm.scope,
			include: 'stats'
		}).then(res => {
			vm.user = res;
		}).catch(err => {
		}).finally(() => {
			$ionicLoading.hide();
		});
	}

	function setInterval() {
		interval = $interval(() => {
			initialize();
		}, 60 * 1000);
	}

	vm.scopeChanged = function() {
		Session.set('statisticsScope', vm.scope);
		$interval.cancel(interval);
		initialize();
		setInterval();
	}

	$scope.$on('$ionicView.enter', function(e) {
		$ionicLoading.show();
		initialize();
		setInterval();
	});

	$scope.$on('$ionicView.leave', function(e) {
		$interval.cancel(interval);
	});
}

export default controller;


// WEBPACK FOOTER //
// ./app/components/statistics/statistics.controller.js